import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function fileUploadValidator(): ValidatorFn {
  // Allowed file types
  const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'text/csv'];
  // Maximum file size (2 MB)
  const maxSizeInMB = 2;
  const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

  return (control: AbstractControl): ValidationErrors | null => {
    const files = control.value as File[];  // Get the array of files from the form control

    if (!files || files.length === 0) {
      return null;  // If no files are selected, skip validation
    }

    // Error object to collect errors for individual files
    let errors: ValidationErrors = {};

    // Iterate through each file to check the validation criteria
    for (let file of files) {
      // Check file type
      const isValidType = allowedTypes.includes(file.type);
      if (!isValidType) {
        errors = { ...errors, invalidType: true };
      }

      // Check file size
      const isValidSize = file.size <= maxSizeInBytes;
      if (!isValidSize) {
        errors = { ...errors, maxSizeExceeded: true };
      }
    }

    // If there are any errors, return them
    return Object.keys(errors).length > 0 ? errors : null;
  };
}
